// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"806":"user","884":"admin","993":"leerstand"}[chunkId] || chunkId) + "." + {"806":"b3afe8d6","884":"9e5e040e","892":"8aaee72e","993":"659d86bb"}[chunkId] + ".css";
};